






import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class ResponseTimeBadge extends Vue {
  @Prop()
  dateCreated!: string;

  @Prop({ default: -1 })
  statusCode!: number;

  @Prop()
  responseTime!: number;

  get cssIconModifier(): string {
    if (this.statusCode) {
      return `badge--${this.statusCode}`;
    }
    return "";
  }
}
